import ImagesCollectionsCollectionBgWebp from '@/public/images/collections/collectionBg.webp';
import ImagesCollectionsCollectionsJpg from '@/public/images/collections/collections.jpg';
import ImagesCollectionsGlobeSvg from '@/public/images/collections/globe.svg';
import ImagesCollectionsInstagramSvg from '@/public/images/collections/instagram.svg';
import ImagesCollectionsSearchSvg from '@/public/images/collections/search.svg';
import ImagesCollectionsSingleCollectionBgPng from '@/public/images/collections/single-collection-bg.png';

export {
  ImagesCollectionsCollectionBgWebp,
  ImagesCollectionsCollectionsJpg,
  ImagesCollectionsGlobeSvg,
  ImagesCollectionsInstagramSvg,
  ImagesCollectionsSearchSvg,
  ImagesCollectionsSingleCollectionBgPng,
};
